import { Box, Button, Text, useDisclosure, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import ModalLayout from '@components/Modal/ModalLayout';
import OrderCard from '@components/OrderCard';
import Pagination from '@components/Pagination';
import { CARD_TYPE, ORDER_PRODUCTS, ORDER_RESOURCE } from '@constants';
import GenericCard from '@components/GenericCard';
import { MdEast } from 'react-icons/md';
import OrderMetadataModal from '@components/Modal/OrderMetadataModal';

const OrdersList = ({
  orders,
  pageNo,
  totalPages,
  handlePageChange,
  onOrderDetailsClick,
  show,
  product = ORDER_PRODUCTS.REMITTANCE,
  orderResource = ORDER_RESOURCE.APP_SERVER,
  isSidebar = false
}) => {

  const {
    isOpen: isEditFlagOpen,
    onOpen: onEditFlagOpen,
    onClose: onEditFlagClose
  } = useDisclosure();

  const [activeFlag, setActiveFlag] = useState({
    orderId: null,
    note: '',
    complianceFlagged: false
  });

  useEffect(() => {
    if (activeFlag?.orderId) onEditFlagOpen();
  }, [activeFlag]);

  const handleFlagClick = (orderData) =>
    setActiveFlag({
      orderId: orderData?.orderId,
      note: orderData?.metadata?.details,
      complianceFlagged: orderData?.metadata?.complianceFlagged
    });

  const renderOrderBasedOnOrderResource = (orderResource, item, idx) => {
    switch (orderResource) {
      case ORDER_RESOURCE.LULU_SERVICE:
        return (
          <GenericCard
            key={idx}
            cardData={item}
            cardType={CARD_TYPE.LULU_FUNNEL_ORDER_CARD}
            maxW="100%"
            ActionButtons={
              item.referredUserId === null
                ? []
                : [
                    <Button
                      key="order-details-button"
                      mt={{ base: 2, md: 0 }}
                      ml={{ base: 0, md: 1 }}
                      rightIcon={<MdEast color="black" />}
                      type="submit"
                      rounded="lg"
                      color="black"
                      colorScheme="brand"
                      alignSelf={{ base: 'center', md: 'center' }}
                      px={5}
                      onClick={() =>
                        onOrderDetailsClick(
                          item.orderId,
                          item.userId,
                          orderResource
                        )
                      }
                    >
                      Order details
                    </Button>
                  ]
            }
          />
        );

      case ORDER_RESOURCE.GOMS_SERVICE:
      case ORDER_RESOURCE.APP_SERVER:
        return (
          <OrderCard
            key={idx}
            orderData={item}
            onOrderDetailsClick={(orderId, orderResource) =>
              onOrderDetailsClick(orderId, item.userId, orderResource)
            }
            onFlagButtonClick={() => handleFlagClick(item)}
            show={show}
            isSidebar={isSidebar}
            orderResource={orderResource}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <ModalLayout isOpen={isEditFlagOpen} onClose={onEditFlagClose}>
        <OrderMetadataModal
          orderId={activeFlag?.orderId}
          onClose={onEditFlagClose}
          initNote={activeFlag?.note}
          initFlag={!activeFlag?.complianceFlagged}
          title={'Update compliance flag'}
          successMessage={`Updated compliance flag for order ${activeFlag?.orderId}`}
          failureMessage={`Failed to update compliance flag for order ${activeFlag?.orderId}`}
        />
      </ModalLayout>
      {!isSidebar && totalPages > 1 && (
        <Box alignSelf={'start'}>
          <Pagination
            totalPages={totalPages}
            currentPage={pageNo + 1}
            onPageChange={handlePageChange}
          />
        </Box>
      )}
      <VStack
        alignSelf={'flex-start'}
        w={{ base: '100%', lg: '100%' }}
        maxW={{ base: '100%', lg: '70rem' }}
        alignItems={'stretch'}
        gap={2}
      >
        {orders &&
          orders.map((item, idx) =>
            product === ORDER_PRODUCTS.REMITTANCE
              ? renderOrderBasedOnOrderResource(orderResource, item, idx)
              : null
          )}
        {orders?.length === 0 && (
          <Box
            p={4}
            borderRadius="xl"
            bg={'backGround'}
            borderWidth="1px"
            borderColor={'whiteAlpha.300'}
          >
            <Text color="white" fontSize="md">
              No orders found.
            </Text>
          </Box>
        )}
      </VStack>
    </>
  );
};

export default OrdersList;
